export const AMAZON_AD_SIZES = [[300,250],[300,600],[728,90],[320,50]];



// WEBPACK FOOTER //
// ./shared_critical/media/constants.js